import { FC } from 'react'

import Separator from 'src/components/ui/atoms/Separator'
import useSidebarStore from 'src/stores/useSidebarStore'
import SidebarFooterDataAvailability from './SidebarFooterDataAvailability'
import SidebarFooterMapping from './SidebarFooterMapping'

const SidebarFooter: FC = () => {
  const isSidebarOpen = useSidebarStore(s => s.isOpen || s.searchInputFocusedId !== null)

  return (
    <div className="flex flex-col pb-4">
      <Separator offsetHorizontal={isSidebarOpen ? 16 : 16} className="bg-geyser my-1" />
      <SidebarFooterMapping />
      <SidebarFooterDataAvailability />
    </div>
  )
}

export default SidebarFooter
